import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import { PublicLayoutComponent } from '../../ui'
import {
  Login,
  Signup,
  SignupConfirmation,
  BudgetRequest,
  PasswordRecovery,
  BudgetConfirmation,
} from '../../pages'

export const PublicRouter = () => (
  <PublicLayoutComponent>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup/confirmation/:signupToken" element={<SignupConfirmation />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/budget-request/:appId" element={<BudgetRequest />} />
      <Route path="/budget-confirmation/:token" element={<BudgetConfirmation />} />
      <Route path="/password-recovery/:id" element={<PasswordRecovery />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </PublicLayoutComponent>
)
